// extracted by mini-css-extract-plugin
export default {"icon":"CountryIcons_icon__5479j","icon-title":"CountryIcons_icon-title__YAOvE","icon-text":"CountryIcons_icon-text__7HeJL"};